export enum VIEWPORT_PANELS {
  MEASUREMENTS = 'measurements',
  SEQUENCE = 'sequence',
}
